import { Component } from '@angular/core';
import { Router } from "@angular/router";
import { SystemSettingService } from '../../services/system-settings.service';
import { ToasterService } from "../../../../common/services/toaster.service";
import { GtrakAuthService } from "../../../authentication/services/gtrak-auth.service";
import { AlertController } from '@ionic/angular';
@Component({
  selector: 'app-custom-site-admin-page',
  templateUrl: 'custom-site-admin.page.html',
  styleUrls: [
    './custom-site-admin.page.scss',
  ]
})
export class CustomerSiteAdminPage {
  settingsFields:any[];
  systemSetting:any[];
   constructor(
        private systemSettingService: SystemSettingService,
        private toasterService: ToasterService,
        private router: Router,
        public authService: GtrakAuthService,
        public alertController:AlertController
      ) { 
  
    }
  loading:boolean=true ;
  customerSiteReports:any;
  groupedReports:any;


  ngOnInit() {
    this.loadData(); 
  }

async loadData() {
    this.loading=false;
    await this.systemSettingService.getCustomerSiteAdmin().then((response) => {
      
        this.customerSiteReports = response;

      });
      
        this.loading=true;
 }
 addNewRecord(){
    this.router.navigate([`admin-page/custom-site-admin/add`]);
 }
 editCustomSiteReport(id){
   this.router.navigate([`admin-page/custom-site-admin/edit/`+id]);
 }
 async deleteCustomSiteReport(id){
  this.loading=false;
  const alert = await this.alertController.create({
      header: 'Delete Account',
      message: 'Are you sure you want to delete report? This will permanently erase data.',
      cssClass: 'custom-alert ',
      buttons: [
        {
          text: 'Delete',
          handler: async () => {
            await  this.systemSettingService.deleteCustomSiteAdmin(id).then((response) => {
                if (response === 'success') {
                  this.toasterService.presentToast(
                    "primary",
                    "The Custom site were deleted.",
                    "Success"
                  );
                  this.loadData();
                } else {
                  this.toasterService.presentToast(
                    "danger",
                    `Error deleting web report.`,
                    "Error"
                  );
                  this.loading=true;
                  return false;
                }
              });
          },
          cssClass: 'alert-button red-text-popup'
        },
        {
          text: 'Cancel',
          cssClass: 'alert-button'
        }
      ],
    });

    await alert.present();
    await alert.onDidDismiss(); 
    this.loading=true;
 }
 async viewCustomerReports(report) {
    this.loading=false;
    if (!report.apP_TARGET) {
      this.toasterService.presentToast(
        "danger",
        "Error",
        "Please add link or query in web_reports table."
      );
      this.loading=true;
      return false;
    }

    const target = report.apP_TARGET.toLowerCase();

    if (report.reportType === 'link' && target.includes('select ')) {
      this.toasterService.presentToast(
        "danger",
        "Error",
        "Invalid target: expected a link, but found a query."
      );
      this.loading=true;
      return false;
    }

    if (report.reportType === 'query'  && !target.includes('select ')) {
      this.toasterService.presentToast(
        "danger",
        "Error",
        "Invalid target: expected a query, but not found."
      );
      this.loading=true;
      return false;
    }

    if (report.reportType === 'link') {
      if(report.apP_TARGET!=null){
      this.router.navigate([`admin-page/customer-site-reports/${report.apP_TARGET}`]);
      }
      else{
         this.toasterService.presentToast(
        "danger",
        "Error",
        "Please check web_reports table."
      );
      this.loading=true;
      return false;
      }
    } 
    else if (report.reportType === 'query') {
      this.router.navigate([`admin-page/customer-site-reports/query-view/${report.id}`]);
    } 
    else {
      this.toasterService.presentToast(
        "danger",
        "Error",
        "Please check web_reports table."
      );
      this.loading=true;
      return false;
    }
        this.loading=true;
  }

}